import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { Box } from '../Box';
import { BirdLayoutState } from '../../store/birdLayout/BirdLayoutState';
import { useResizeObserverRef } from '@sas/nova-commons/hooks/useResizeObserver';
export const MediaBase = ({ id, setPosition }) => {
    const [ref] = useResizeObserverRef(({ contentRect }) => {
        setPosition(id, contentRect);
    });
    return (_jsx("div", Object.assign({ style: {
            display: 'flex',
            flexShrink: 1,
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
        }, ref: ref }, { children: _jsx(Box, { id: id }) })));
};
export const Media = connect(null, { setPosition: BirdLayoutState.actions.setPosition })(MediaBase);
